import { useState, useEffect } from "react";

import { getDoc, serverTimestamp, increment } from "firebase/firestore";
import { getBatch, getRef } from "lib/firebase";

import { CurrentUser } from "lib/type";

let changingLike = false;

export const useCommentLike = (
  author: CurrentUser,
  user: CurrentUser,
  articleID: string,
  commentID: string,
  likeCount: number
) => {
  const [currentLikeCount, setCurrentLikeCount] = useState(likeCount);

  const [isCurrentLiked, setIsCurrentLiked] = useState(false);
  useEffect(() => {
    if (!author || !user || !articleID) return;
    const loadCurrentLiked = async () => {
      const commentPath = `${author.uid}/publicArticles/${articleID}/comments/${commentID}`;
      const currentLikedRef = getRef(
        "users",
        `${commentPath}/likedUsers/${user.uid}`
      );
      const currentLikedDoc = await getDoc(currentLikedRef);
      setIsCurrentLiked(currentLikedDoc.exists() ? true : false);
    };
    loadCurrentLiked();
  }, [articleID, author, commentID, user]);

  const changeLike = async () => {
    if (!author || !user || changingLike) return;
    changingLike = true;
    const batch = getBatch();
    const commentPath = `${author.uid}/publicArticles/${articleID}/comments/${commentID}`;
    const commentRef = getRef("users", commentPath);
    batch.update(commentRef, {
      likeCount: isCurrentLiked ? increment(-1) : increment(1),
    });
    const likedUserRef = getRef(
      "users",
      `${commentPath}/likedUsers/${user.uid}`
    );
    const likedUserDoc = await getDoc(likedUserRef);
    likedUserDoc.exists()
      ? batch.delete(likedUserRef)
      : batch.set(likedUserRef, {
          likedUid: user.uid,
          commentID: commentID,
          createdAt: serverTimestamp(),
        });
    await batch.commit().catch((err) => {
      console.log(err);
      alert("いいねに失敗しました。");
    });
    setCurrentLikeCount((prevLikeCount: number) =>
      isCurrentLiked ? prevLikeCount - 1 : prevLikeCount + 1
    );
    setIsCurrentLiked(isCurrentLiked ? false : true);
    changingLike = false;
  };

  return { isCurrentLiked, currentLikeCount, changeLike };
};
